<script>
import Constants from '../constants';
export default {
  name: 'snsIcons',
  props: {
    isWhite: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openTwitter() { window.open(Constants.SNS.TWITTER, '_blank'); },
    openSoundCloud() { window.open(Constants.SNS.SOUND_CLOUD, '_blank'); },
    openYoutube() { window.open(Constants.SNS.YOUTUBE, '_blank'); },
    openNiconico() { window.open(Constants.SNS.NICONICO, '_blank'); },
    openBooth() { window.open(Constants.SNS.BOOTH, '_blank'); },
    openInstagram() { window.open(Constants.SNS.INSTAGRAM, '_blank'); },
    openBandCamp() { window.open(Constants.SNS.BANDCAMP, '_blank'); },
    openThreads() { window.open(Constants.SNS.THREADS, '_blank');},
    openBluesky() { window.open(Constants.SNS.BLUESKY, '_blank');},
    openFacebook() { window.open(Constants.SNS.FACEBOOK, '_blank');},
    openTiktok() { window.open(Constants.SNS.TIKTOK, '_blank');},
  },
};
</script>

<template>
  <div class="sns-container" :class="[$mq, isWhite? 'is-white' : '']">
    <i
      class="icon twitter"
      :title="$t('message.snsName.twitter')"
      @click="openTwitter"
    ></i>
    <i
      class="icon instagram"
      :title="$t('message.snsName.instagram')"
      @click="openInstagram"
    ></i>
    <i
      class="icon youTube"
      :title="$t('message.snsName.youTube')"
      @click="openYoutube"
    ></i>
    <i
      class="icon tiktok"
      :title="$t('message.snsName.tikTok')"
      @click="openTiktok"
    ></i>
    <i
      class="icon bluesky"
      :title="$t('message.snsName.bluesky')"
      @click="openBluesky"
    ></i>
    <i
      class="icon bandcamp"
      :title="$t('message.shop.bandcamp')"
      @click="openBandCamp"
    ></i>
    <i
      class="icon booth"
      :title="$t('message.shop.booth')"
      @click="openBooth"
    ></i>
    <i
      class="icon facebook"
      :title="$t('message.snsName.faceBook')"
      @click="openFacebook"
    ></i>
    <i
      class="icon threads"
      :title="$t('message.snsName.threads')"
      @click="openThreads"
    ></i>
    <i
      class="icon niconico"
      :title="$t('message.snsName.niconico')"
      @click="openNiconico"
    ></i>
    <i
      class="icon soundCloud"
      :title="$t('message.snsName.soundCloud')"
      @click="openSoundCloud"
    ></i>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";

  .sns-container {
    display: flex;
    .icon {
      width: 40px;
      height: 40px;
      cursor: pointer;
      @include bgCenter;
      transform: scale(1);
      transition: 0.1s ease-out;
      &.twitter {background-image: url(../assets/img/sns/twitter.svg);}
      &.instagram {background-image: url(../assets/img/sns/instagram.svg);}
      &.soundCloud {background-image: url(../assets/img/sns/soundCloud.svg);}
      &.youTube {background-image: url(../assets/img/sns/youTube.svg);}
      &.niconico {background-image: url(../assets/img/sns/niconico.svg);}
      &.booth {background-image: url(../assets/img/sns/booth.svg);}
      &.bandcamp {background-image: url(../assets/img/sns/bandCamp.svg);}
      &.threads {background-image: url(../assets/img/sns/threads.svg);}
      &.bluesky {background-image: url(../assets/img/sns/bluesky.svg);}
      &.facebook {background-image: url(../assets/img/sns/facebook.svg);}
      &.tiktok {background-image: url(../assets/img/sns/tiktok.svg);}
      &:hover {transform: scale(1.1) rotate(10deg) ;}
    }

    &.is-white {
      .icon {
        &.threads {background-image: url(../assets/img/sns/threadsWhite.svg);}
        &.niconico {background-image: url(../assets/img/sns/niconicoWhite.svg);}
        &.tiktok {background-image: url(../assets/img/sns/tiktokWhite.svg);}
      }
    }
    // responsible -----------------------------------------------
    &.viewLg {
      justify-content:center;
      .icon {margin: 0 20px;}
    }
    &.viewMd {
      flex-wrap: wrap;
      justify-content:space-around;
      .icon {margin: 0 10px;}
    }
    &.viewSm {
      flex-wrap: wrap;
      justify-content:space-around;
      .icon {margin: 0 10px;}
    }
  }
</style>
